import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TechLoss } from 'src/app/models/tech/tech-loss.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { TechService } from 'src/app/services/tech.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-user-tech-loss-dialog',
  template: `<app-dea-dialog-wrapper>
    <div class="fw-semibold fs-4">
      {{ this.data?.docId === undefined ? '' : 'Modifica ' }}Furto / Smarrimento
    </div>
    <div class="v-spacer"></div>
    <form
      [formGroup]="userLossForm"
      enctype="multipart/form-data"
      class="m-0 p-0 d-flex flex-column gap-3"
    >
      <app-dea-label [label]="'Note (Opzionali):'"></app-dea-label>
      <textarea
        formControlName="note"
        class="form-control dea-form-input"
        placeholder="Note"
        rows="3"
      ></textarea>
      <app-dea-label [label]="'Allegato: (Opzionale)'"></app-dea-label>
      <div>
        <input
          type="file"
          formControlName="file"
          accept="image/png,image/jpeg,.pdf"
          class="form-control dea-form-input mb-1"
          placeholder="Seleziona un file"
          (change)="onFileChange($event)"
        />
        <div class="fw-lighter ps-1" style="font-size: 0.5rem;">
          Formati accettati: PDF - PNG/JPG/JPEG | Dimensione Masima: 48Mb x 1
        </div>
      </div>
      <div class="text-danger">{{ error?.message }}</div>
    </form>
    <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
      <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">
        Annulla
      </button>
      <button
        *ngIf="!loading"
        (click)="onConfirm()"
        class="px-5 py-1"
        mat-flat-button
        color="primary"
      >
        {{ this.data?.docId === undefined ? 'Crea' : 'Modifica' }}
      </button>
      <button *ngIf="loading" class="px-5 py-1" mat-flat-button disabled>
        <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
        {{ this.data?.docId === undefined ? 'Creazione' : 'Aggiornamento' }}
      </button>
    </div>
  </app-dea-dialog-wrapper>`,
  styles: [],
})
export class UserTechLossDialogComponent {
  public loading: boolean = false;
  public error?: ApiError;

  public userLossForm: FormGroup;

  constructor(
    private _dialogRef: MatDialogRef<UserTechLossDialogComponent>,
    private _techService: TechService,
    @Inject(MAT_DIALOG_DATA)
    public data?: {
      userId?: string;
      deviceId?: string;
      docId?: string;
    }
  ) {
    this.userLossForm = new FormGroup({
      owner: new FormControl(this.data?.userId),
      device: new FormControl(this.data?.deviceId),
      note: new FormControl(null),
      file: new FormControl(null),
      document: new FormControl(null),
    });
    if (this.data?.docId !== undefined) {
      this._techService.getTechBlockDetails(this.data?.docId).subscribe({
        next: (data: any) => {
          const lossData = new TechLoss(data.data);
          this.userLossForm = new FormGroup({
            owner: new FormControl(lossData?.owner?.id),
            device: new FormControl(lossData?.device?.id),
            note: new FormControl(lossData?.note),
            file: new FormControl(null),
            document: new FormControl(null),
          });
        },
        error: (error: any) => console.error('Get Tech Details Error: ', error),
      });
    }
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.userLossForm?.patchValue({ document: file });
    }
  }

  onConfirm(): void {
    this.loading = true;
    this.error = undefined;
    const formData = new FormData();
    var data = this.userLossForm.value;
    formData.append('owner', data.owner);
    formData.append('device', data.device);
    formData.append('note', data.note?.trim() || '');
    if (data.document) {
      const file: any = this.userLossForm?.get('document')?.value;
      formData.append(
        'documento',
        file,
        file.name || new Date().toISOString().slice(0, 10)
      );
    }
    const subscription = {
      next: (_: any) => this._dialogRef.close(true),
      error: (error: any) => {
        this.error = new ApiError(error);
        console.error('User Post/Patch Loss Error: ', error);
      },
    };
    if (this.data?.docId) {
      this._techService
        .patchLoss(formData, this.data?.docId)
        .subscribe(subscription)
        .add(() => (this.loading = false));
    } else {
      this._techService
        .postLoss(formData, this.data?.userId)
        .subscribe(subscription)
        .add(() => (this.loading = false));
    }
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
